import bannerImg from './banners/woman-helping-man-gym.jpg';

const anamneseCorridaIniciante = (t) => ({
    id: 'anamnese-corrida-iniciante',
    title: t('templates.items.anamneseCorridaIniciante.title'),
    description: t('templates.items.anamneseCorridaIniciante.description'),
    indicatedFor: t('templates.audiences.runningCoaches'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.anamneseCorridaIniciante.summary.runningExperience'),
        t('templates.items.anamneseCorridaIniciante.summary.previousInjuries'),
        t('templates.items.anamneseCorridaIniciante.summary.raceGoal'),
        t('templates.items.anamneseCorridaIniciante.summary.currentRoutine'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.anamneseCorridaIniciante.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.anamneseCorridaIniciante.form.profile.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseCorridaIniciante.form.profile.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.anamneseCorridaIniciante.form.profile.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: t('templates.items.anamneseCorridaIniciante.form.profile.experience.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.anamneseCorridaIniciante.form.profile.experience.minLabel'),
                            maxLabel: t('templates.items.anamneseCorridaIniciante.form.profile.experience.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.options.fiveKm') },
                                { id: 'opt-2', label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.options.tenKm') },
                                { id: 'opt-3', label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.options.halfMarathon') },
                                { id: 'opt-4', label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.options.marathon') },
                                { id: 'opt-5', label: t('templates.items.anamneseCorridaIniciante.form.profile.distance.options.unsure') },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.anamneseCorridaIniciante.form.health.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.anamneseCorridaIniciante.form.health.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'yes_no_maybe',
                        label: t('templates.items.anamneseCorridaIniciante.form.health.injury.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.anamneseCorridaIniciante.form.health.routine.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: t('templates.items.anamneseCorridaIniciante.form.health.currentWeight.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default anamneseCorridaIniciante;
